<template>
  <JyPagebody :activatedLoad="loadData">
    <el-form label-width="150px" size="small" :model="editData" :rules="rules" v-loading="viewLoading" ref="editForm" class="flex-grow-1 overflow-y-auto p-4 bg-white">
      <el-row type="flex" class="flex-wrap">
        <form-item label="一版分类" prop="cate1" fill="4">
          <el-checkbox-group v-model="editData.cate1">
            <el-checkbox v-for="item in newscateList" :key="'1'+ item.id" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </form-item>
        <form-item v-for="(item, index) in editData.cate1" :key="'1-'+ index" :prop="'cate1n'+ (index)" :rules="rules.num">
          <label slot="label">{{ cateMap[item] ? cateMap[item].name : '--' }} - 新闻数</label>
          <el-input v-model.number="editData['cate1n'+ index]"></el-input>
        </form-item>
        <form-item label="二版分类" prop="cate2" fill="4">
          <el-checkbox-group v-model="editData.cate2">
            <el-checkbox v-for="item in newscateList" :key="'2'+ item.id" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </form-item>
        <form-item v-for="(item, index) in editData.cate2" :key="'2-'+ index" :prop="'cate2n'+ (index)" :rules="rules.num">
          <label slot="label">{{ cateMap[item] ? cateMap[item].name : '--' }} - 新闻数</label>
          <el-input v-model.number="editData['cate2n'+ index]"></el-input>
        </form-item>
        <form-item label="三版分类" prop="cate3" fill="4">
          <el-checkbox-group v-model="editData.cate3">
            <el-checkbox v-for="item in newscateList" :key="'3'+ item.id" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </form-item>
        <form-item v-for="(item, index) in editData.cate3" :key="'3-'+ index" :prop="'cate3n'+ (index)" :rules="rules.num">
          <label slot="label">{{ cateMap[item] ? cateMap[item].name : '--' }} - 新闻数</label>
          <el-input v-model.number="editData['cate3n'+ index]"></el-input>
        </form-item>
        <form-item label="二维码" prop="qrcode" fill="4">
          <div style="line-height:1.3;">
            <div v-if="editData.qrcode" class="d-flex">
              <img :src="rootPath + editData.qrcode" style="height:4rem;" >
              <a href="javascript:;" class="text-danger ml-4" @click="removePic('qrcode')">删除</a>
            </div>
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :on-success="function (res, file, filelist) { return handleUploadSuccess(res, filelist, 'qrcode') }"
              :before-upload="beforeUpload">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过20MB，尺寸：120 × 120</div>
            </el-upload>
          </div>
        </form-item>
        <form-item label="快速通道背景图" prop="img1" fill="4">
          <div style="line-height:1.3;">
            <div v-if="editData.img1" class="d-flex">
              <img :src="rootPath + editData.img1" style="height:4rem;" >
              <a href="javascript:;" class="text-danger ml-4" @click="removePic('img1')">删除</a>
            </div>
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :on-success="function (res, file, filelist) { return handleUploadSuccess(res, filelist, 'img1') }"
              :before-upload="beforeUpload">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过20MB，尺寸：1250 × 132</div>
            </el-upload>
          </div>
        </form-item>
        <form-item label="中部banner图" fill="4">
          <div style="line-height:1.3;">
            <div v-if="editData.img2" class="d-flex">
              <img :src="rootPath + editData.img2" style="height:4rem;" >
              <a href="javascript:;" class="text-danger ml-4" @click="removePic('img2')">删除</a>
            </div>
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :on-success="function (res, file, filelist) { return handleUploadSuccess(res, filelist, 'img2') }"
              :before-upload="beforeUpload">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过20MB，尺寸：1190 × 109</div>
            </el-upload>
          </div>
        </form-item>
      </el-row>
    </el-form>
    <div slot="footer">
      <JyButton type="success" @click="doSave" icon="check">保存设置</JyButton>
    </div>
  </JyPagebody>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import tools from 'jyutils/tools';
export default {
  components: {  },
  mixins: [tools],
  data() {
    return {
      viewLoading: false,
      saveLoading: false,
      rules: {
        cate1: {type:'array', required:true, len:4, message:'请选择4个一版分类！'},
        cate2: {type:'array', required:true, len:4, message:'请选择4个二版分类！'},
        cate3: {type:'array', required:true, len:2, message:'请选择2个三版分类！'},
        qrcode: {required:true, message:'请上传二维码！'},
        img1: {required:true, message:'请上传快速通道背景！'},
        num: {required:true, type:'integer', min:0, message:'请输入数字！'},
      }
    }
  },
  created () {
    this.editData = {cate1:[], cate2:[], cate3:[]}
  },
  computed: {
    ...mapGetters({
      newscateList: [types.BASE_LOAD.newscateList],
      loading: [types.BASE_LOAD.baseLoading]
    }),
    cateMap() {
      let map = {};
      this.newscateList.forEach(d => {
        map[d.id] = d;
      });
      return map;
    }
  },
  watch: {
    'editData.cate1'(val) {
      this.updateCate1(val);
    },
    'editData.cate2'(val) {
      this.updateCate2(val);
    },
    'editData.cate3'(val) {
      this.updateCate3(val);
    },
  },
  beforeRouteLeave (to, from, next) {
    this.confirmSave(
      `未保存首页设置，确定要离开吗？`,
      next,
      () => {
        next(false);
      }
    );
  },
  methods: {
    loadData() {
      this.viewLoading = true;
      this.doGet({
        url: 'sys/setting/other',
        okcb: (json) => {
          let cate1num = {};
          (json.cate1num ? json.cate1num.split(',') : []).forEach((d, i) => {
            cate1num[`cate1n${i}`] = d ? parseInt(d) : null;
          });

          let cate2num = {};
          (json.cate2num ? json.cate2num.split(',') : []).forEach((d, i) => {
            cate2num[`cate2n${i}`] = d ? parseInt(d) : null;
          });

          let cate3num = {};
          (json.cate3num ? json.cate3num.split(',') : []).forEach((d, i) => {
            cate3num[`cate3n${i}`] = d ? parseInt(d) : null;
          });

          this.editData = Object.assign({}, this.editData, json, {
            ...cate1num,
            ...cate2num,
            ...cate3num,
            cate1: json.cate1 ? json.cate1.split(',') : [],
            cate2: json.cate2 ? json.cate2.split(',') : [],
            cate3: json.cate3 ? json.cate3.split(',') : [],
          });

          // set origin data for check modified
          this.setOriaData();
        },
        cb: () => {
          this.viewLoading = false;
        }
      });
      if (!this.newscateList || !this.newscateList.length) {
        this.$store.dispatch(types.BASE_LOAD.newscateList);
      }
    },
    updateCate1(val) {
      val.forEach((d, index) => {
        if (!this.editData['cate1n'+ index]) {
          this.$set(this.editData, 'cate1n'+ (index), null);
        }
      });
    },
    updateCate2(val) {
      val.forEach((d, index) => {
        if (!this.editData['cate2n'+ index]) {
          this.$set(this.editData, 'cate2n'+ (index), null);
        }
      });
    },
    updateCate3(val) {
      val.forEach((d, index) => {
        if (!this.editData['cate3n'+ index]) {
          this.$set(this.editData, 'cate3n'+ (index), null);
        }
      });
    },
    handleUploadSuccess(res, filelist, t) {
      if (res.obj && res.obj.pic) {
        this.$set(this.editData, t, res.obj.pic);
        // this.editData[t] = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    removePic(t) {
      this.msgbox('确定要删除吗？', () => {
        this.editData[t] = null;
      })
    },
    doSave() {
      this.submitform().then(() => {
        let postData = {};
        this.saveLoading = true;
        Object.assign(postData, this.editData);

        let cate1num = [];
        postData.cate1.forEach((d, index) => {
          cate1num.push(postData['cate1n'+ (index)]);
        });
        postData.cate1num = cate1num.join(',');
        postData.cate1 = postData.cate1.join(',');

        let cate2num = [];
        postData.cate2.forEach((d, index) => {
          cate2num.push(postData['cate2n'+ (index)]);
        });
        postData.cate2num = cate2num.join(',');
        postData.cate2 = postData.cate2.join(',');

        let cate3num = [];
        postData.cate3.forEach((d, index) => {
          cate3num.push(postData['cate3n'+ (index)]);
        });
        postData.cate3num = cate3num.join(',');
        postData.cate3 = postData.cate3.join(',');

        // console.log(this.editData)
        this.doPost({
          url: 'sys/setting/saveOther',
          data: postData,
          okcb: () => {
            this.$message.success('保存成功！');

            // set origin data for check modified
            this.setOriaData();
          },
          cb: () => {
            this.saveLoading = false;
          }
        });
      })
      .catch(() => {
        
      });
    }
  }
}
</script>
